<template>
    <div>
        <div class="m-scene" id="main">
            <div class="project__hero">
                <section class="banner-bg desktop" :style="{ backgroundImage: 'url(' + mainUrl + ')' }"></section>

                <section class="banner-bg iphone portrait"
                         :style="{ backgroundImage: 'url(' + iphonePortraitUrl + ')' }"></section>
                <section class="banner-bg iphone landscape"
                         :style="{ backgroundImage: 'url(' + iphoneLandscapeUrl + ')' }"></section>

                <section class="banner-bg ipad portrait"
                         :style="{ backgroundImage: 'url(' + ipadPortraitUrl + ')' }"></section>
                <section class="banner-bg ipad landscape"
                         :style="{ backgroundImage: 'url(' + ipadLandscapeUrl + ')' }"></section>

                <section class="banner-bg ipadPro portrait"
                         :style="{ backgroundImage: 'url(' + ipadProPortraitUrl + ')' }"></section>
                <section class="banner-bg ipadPro landscape"
                         :style="{ backgroundImage: 'url(' + ipadProLandscapeUrl + ')' }"></section>

                <div class="outer-container after-header">
                    <h1 class="projectpage_name">{{ $prismic.richTextAsPlain(fields.project_name) }}</h1>
                    <p class="projectpage-meta">
                        <span class="client">{{ $prismic.richTextAsPlain(fields.project_client) }}</span>
                        <!--span class="created-at">{{ $prismic.richTextAsPlain(fields.project_year) }}</span-->
                    </p>
                </div>
            </div>

            <!-- Slice Block Component tag -->
            <div class="project__content">
                <slices-block :slices="slices"/>
                <footer-prismic/>
            </div>

        </div>
    </div>
</template>

<script>
    //Importing all the slices components
    import SlicesBlock from '../components/SlicesBlock.vue'
    import FooterPrismic from "../components/FooterPrismic";

    export default {
        name: 'project',
        components: {
            FooterPrismic,
            SlicesBlock,

        },
        data() {
            return {
                dateOptions: { day: '2-digit', month: '2-digit', year: 'numeric' },
                documentId: '',
                meta: {
                    seo_title: null,
                    seo_description: null
                },
                fields: {
                    project_name: null,
                    project_client: null,
                    project_year: null,
                    link_to_project: null,
                    project_image: null,
                },
                mainUrl: {},
                iphonePortraitUrl: {},
                iphoneLandscapeUrl: {},
                ipadPortraitUrl: {},
                ipadLandscapeUrl: {},
                ipadProPortraitUrl: {},
                ipadProLandscapeUrl: {},
                slices: [],
                languageCode: {},
                show: false,
            }
        },
        metaInfo () {
            return {
                title: this.meta.seo_title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.meta.seo_description }
                ]
            }
        },
        methods: {
            getContent(uid) {
                //Query to get project content
                this.$prismic.client.getByUID('project', uid)
                    .then((document) => {
                        if (document) {
                            this.documentId = document.id
                            this.fields.project_name = document.data.project_name;
                            this.fields.project_client = document.data.project_client;
                            this.fields.link_to_project = document.data.link_to_project;
                            this.fields.project_year = document.data.project_year;
                            this.fields.page_title = document.data.page_title;
                            this.meta.seo_title = document.data.seo_title;
                            this.meta.seo_description = document.data.seo_description;

                            //this.fields.project_image = document.data.project_image.url;
                            // images
                            const image = document.data.project_image

                            this.mainUrl = image.url;                     // main image
                            this.iphonePortraitUrl = image.iphone_portrait.url;   // iphone portrait
                            this.iphoneLandscapeUrl = image.iphone_landscape.url;  // iphone landscape

                            this.ipadPortraitUrl = image.ipad_portrait.url;       // ipad portrait
                            this.ipadLandscapeUrl = image.ipad_landscape.url;      // ipad landscape

                            this.ipadProPortraitUrl = image.ipad_pro_portrait.url;   // ipad pro portrait
                            this.ipadProLandscapeUrl = image.ipad_pro_landscape.url;  // ipad pro landscape

                            //Set slices as variable
                            this.slices = document.data.body
                            const languageCode = document.lang;


                            document.alternate_languages.forEach(function (altLang) {
                                const id = altLang.id;
                                const uid = altLang.uid;
                                const type = altLang.type;
                                const languageCode = altLang.lang;
                            });
                        } else {
                            //returns error page
                            this.$router.push({name: 'not-found'})
                        }
                    })
            },
            track () {
                this.$gtag.pageview({
                    page_path: '/projects',
                })
            }
        },
        created() {
            this.getContent(this.$route.params.uid)
        },
        beforeRouteUpdate(to, from, next) {
            this.getContent(to.params.uid)
            next()
        }
    }
</script>

<style lang="scss">
    @keyframes heroslideup {
        0% {
            height: 100vh;
        }
        75% {
            height: 100vh;
        }
        100% {
            height: 60vh;
        }
    }
    @keyframes heroslideupMobile {
        0% {
            height: 100vh;
        }
        50% {
            height: 100vh;
        }
        100% {
            height: 50vh;
        }
    }


    .m-scene {

        .scene_element {
            animation-duration: 0.25s;
            transition-timing-function: ease-in;
            animation-fill-mode: both;

        }

        /** An element that fades in */
        .scene_element--fadein {
            animation-name: fadeIn;
        }

        /** An element that fades in and slides up */
        .scene_element--fadeinup {
            animation-name: fadeInUp;
        }

        /** An element that fades in and slides from the right */
        .scene_element--fadeinright {
            animation-name: fadeInRight;
        }

    }
    .project__hero {
        .banner-bg {
            background-repeat: no-repeat;
            background-size: cover;
            min-width: 100%;
            height: 60vh;
            animation-name: heroslideup;
            animation-duration: 2s;
            @media (max-width: 768px) {
                animation-name: heroslideupMobile;
                height: 50vh;
            }
        }

        .project-part.single a {
            text-decoration: none;
            background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.8) 75%);
            background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.8) 75%);
            background-repeat: repeat-x;
            background-size: 2px 2px;
            background-position: 0 23px;
        }
    }
    .after-header,
    .banner-content.container {
        position: absolute;
        top: 40%;
        padding: 0 0 0 40px;
        width: 50%;
        margin-left: 10%;
        animation-name: slide-up;
        animation-duration: 1s;
        @media (max-width: 767px) {
            padding: 0 5%;
            margin:0;
            width: 90%;
            top: 30vh;
        }
        &:before {
            content: "";
            position: absolute;
            top: 2px;
            left: 0;
            height: calc(100% + 0px);
            -webkit-transform: scale(0);
            -ms-transform: scale(0);
            transform: scale(0);
            -webkit-transform-origin: top;
            -ms-transform-origin: top;
            transform-origin: top;
            width: 1px;
            background-color: #126f95;
            transition: -webkit-transform .6s cubic-bezier(.22, .61, .36, 1) 0s;
            transition: transform .6s cubic-bezier(.22, .61, .36, 1) 0s;
            transition: transform .6s cubic-bezier(.22, .61, .36, 1) 0s, -webkit-transform .6s cubic-bezier(.22, .61, .36, 1) 0s;
        }

        &:hover {
            &:before {
                -webkit-transform: scale(1);
                -ms-transform: scale(1);
                transform: scale(1);
            }
        }

        & .projectpage_name,
        & .client,
        & .banner-title,
        & .banner-description {
            width: 90%;
            /*max-width: 490px;*/
            color: #fff;
            text-shadow: 0 0 15px #000;
        }

        & .projectpage_name,
        & .banner-title {
            color: #ffffff;
            font-size: 70px;
            font-weight: 900;
            line-height: 70px;
            @media (max-width: 767px) {
                font-size: 40px;
                line-height: 40px;
            }
        }

        & .projectpage-meta,
        & .banner-description {
            text-transform: uppercase;
            font-size: 20px;
            text-align: left;
            margin-bottom: 0;
        }

    }

    .project__content {
        background-color: #fff;
        position: relative;
    }

    /* Media Queries */
    @media (max-width: 767px) {
        .project__content {
            .banner-bg {
                height: 75vh;
            }
            .after-header {
                position: absolute;
                top: 50vh;
                padding: 0 5%;
                margin:0;
                height: 25vh;
                overflow: hidden;
            }
            .after-header h1 {
                font-size: 45px;
                line-height: 50px;
                color: #fff;
            }
            .project-part pre {
                font-size: 14px;
            }
            .projectpage-meta {
                font-size: 16px;
            }
        }

        breadcrumbs {
            position: relative;
            left: 5%;
        }
    }

    @media screen and (min-width: 768px) {
        .projectpage-meta {
            font-size: 16px;
        }
        span.arrow-down {
            display: none;
        }
    }

</style>
